import { brandSecondary } from '../../../../styles/colors';
import { SvgIcon } from '../SvgIcon';

const initialWidth = 11;
const initialHeight = 11;

export const PlusIconThin = ({
	className,
	fillColor,
	height = initialHeight,
	width = initialWidth,
}: {
	className?: string;
	fillColor?: string;
	height?: number;
	width?: number;
}) => {
	return (
		<SvgIcon
			className={`plus-icon-thin ${className || ''}`}
			height={height}
			width={width}
			viewBox={`0 0 ${initialWidth} ${initialHeight}`}
		>
			<path
				fill={fillColor || brandSecondary}
				fillRule='evenodd'
				d='M6.25,4.75 L11,4.75 L11,6.25 L6.25,6.25 L6.25,11 L4.75,11 L4.75,6.25 L0,6.25 L0,4.75 L4.75,4.75 L4.75,0 L6.25,0 L6.25,4.75 Z'
			/>
		</SvgIcon>
	);
};
